// Meta Pixel tracking helpers. The base pixel script lives in index.html and
// initializes `window.fbq`. These helpers safely no-op if `fbq` is unavailable
// (e.g. SSR, blocked by an ad blocker, or not yet loaded).

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

type PixelParams = Record<string, unknown>;

export function trackEvent(eventName: string, params?: PixelParams): void {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  try {
    if (params) {
      window.fbq("track", eventName, params);
    } else {
      window.fbq("track", eventName);
    }
  } catch (err) {
    console.warn("Meta Pixel trackEvent failed:", err);
  }
}

export function trackPageView(): void {
  trackEvent("PageView");
}
